import PropTypes from "prop-types";
import React from "react";

import { className } from "./audienceStyles";

/**
 * A checkbox that's styled to look like a button that toggles on & off. Any additional props will be placed on the
 * root element.
 */
export default class ToggleButton extends React.PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        value: PropTypes.any.isRequired,
        isSelected: PropTypes.bool.isRequired,
        label: PropTypes.node.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        disabled: false
    };

    render() {
        const {
            disabled,
            value,
            isSelected,
            label,
            onChange,
            ...props
        } = this.props;

        const labelClassName = className(
            "toggleButton",
            isSelected ? "selected" : "unselected",
            disabled && "disabled"
        );

        return (
            <label {...labelClassName} {...props}>
                <input
                    type="checkbox"
                    value={value}
                    disabled={disabled}
                    defaultChecked={isSelected}
                    onChange={disabled ? null : onChange}
                />
                <span {...className("label")}>{label}</span>
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/ToggleButton.js